import { assocIn } from 'icepick';
import type { Action } from '../action-creators/index.tsx';
import * as actions from '../action-types/index.tsx';
import { defaultState as initialState } from '../default-state.tsx';
import type { State } from '../model.tsx';

const rootReducer = (state: State = initialState, action: Action) => {
	switch (action.type) {
		case actions.FETCH_DATA_SUCCESS:
			return assocIn(state, ['locations'], action.payload);
		case actions.SET_CONTEXT:
			return assocIn(state, ['context'], action.payload);
		case actions.CANCEL_DIALOG:
			return assocIn(state, ['locations'], {});
		default:
			break;
	}

	return state;
};

export default rootReducer;
